import { useMemo } from 'react';

import { useStores } from 'bringg-web/recipes';
import useAutomationTranslations from '../utils/use-automation-translations';

const useTeamsTag = (teamIds: number[]): string => {
	const { teamsStore } = useStores();
	const { allTeams } = useAutomationTranslations();

	return useMemo(() => {
		if (teamIds.length === 0) {
			return allTeams;
		}

		if (teamIds.length === 1) {
			return teamsStore.get(teamIds[0])?.name;
		}

		return `${teamIds.length} Teams`;
	}, [teamIds, teamsStore, allTeams]);
};

export default useTeamsTag;
